/* eslint-disable no-unused-vars */
import { Icon, Modal } from "semantic-ui-react";
import AccordionItem from "./AccordionItem";
import Lighting from "./Lighting";
import Select from "react-select";
import { useContext, useState, useEffect } from "react";
import { SettingsContext } from "../context";
import axios from "axios";

import HotSpots from "./HotSpotPage";
import SsaoParameters from "./SsaoParameters";
import AnimationPage from "./AnimationPage";
import VariantPage from "./VariantPage";
import CombinePage from "./CombinePage";
import ProductPartPage from "./ProductPartPage";
import MaterialInfo from "./MaterialInfo";

function ModelViewerInfo() {
  const {
    environment,
    setEnviroment,
    authenticationToken,
    environmentList,
    setEnvironmentList,
  } = useContext(SettingsContext);
  const [environmentFile, setEnvironmentFile] = useState();
  const [notification, setNotification] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    getEnvironmentList();
  }, []);

  const getEnvironmentList = () => {
    if (environmentList.length > 0) return;

    getEnvironmentListFromServer();
  };

  const getEnvironmentListFromServer = async () => {
    if (environmentList.length > 0) return;

    axios
      .get(process.env.REACT_APP_BACKEND_API + "editor/list/environment", {
        headers: {
          Authorization: authenticationToken,
        },
      })
      .then((res) => {
        res.data.map((env) => {
          setEnvironmentList((prevValues) => {
            return [
              ...prevValues,
              { value: env.id, label: env.name, text: env.url },
            ];
          });
        });
      });
  };

  const uploadEnvironment = async () => {
    setNotification("Environment is uploading.");
    setModalOpen(true);

    let formData = new FormData();
    formData.append("environment", environmentFile);

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_API + "editor/add/environment",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authenticationToken,
      },
    }).then(
      (res) => {
        setNotification("Environment uploaded.");
        setEnvironmentList([]);
        getEnvironmentListFromServer();

        setTimeout(() => {
          setModalOpen(false);
          setNotification(null);
        }, 2000);
      },
      (rej) => {
        setNotification("Environment couldnt uploaded.");

        setTimeout(() => {
          setModalOpen(false);
          setNotification(null);
        }, 5000);
      }
    );
  };

  const handleEnvironment = (e) => {
    let modelViewer = document.getElementById("modelViewer");
    setEnviroment(e);
    modelViewer.environmentImage = e.text == null ? "" : e.text;
  };

  return (
    <div className="model">
      <div className="modelChild">
        <div>
      <div >
        <ProductPartPage></ProductPartPage>
        <MaterialInfo></MaterialInfo>
      </div>

          <AccordionItem header={"Environment Image"}>
            <div className="accordion">
              <div className="environmentDrop">
                <div style={{ width: "100%" }}>
                  <Select
                    menuPosition="fixed"
                    isSearchable
                    isClearable
                    onChange={(e) => {
                      handleEnvironment(e);
                    }}
                    options={environmentList}
                    selection
                    defaultValue={environment}
                    placeholder="Environment Image"
                  />
                </div>
                <div>
                  <button className="saveButton">
                    <label htmlFor="uploadEnv">
                      <Icon name="upload" />{" "}
                    </label>
                    <input
                      type="file"
                      hidden
                      id="uploadEnv"
                      onChange={(e) => {
                        setEnvironmentFile(e.target.files[0]);
                      }}
                    />
                  </button>

                  <button
                    className="saveButton"
                    onClick={() => uploadEnvironment()}
                  >
                    Uplaod
                  </button>
                </div>
              </div>
            </div>
          </AccordionItem>
        </div>
      </div>
      <div>
        <Lighting />
      </div>
      <div>
        <div style={{
          display:"none",
        }}>
          
          <HotSpots />
        </div>
      </div>

      <div>
        <div>
          <AnimationPage />
        </div>
      </div>
      <div>
        <div>
          <VariantPage></VariantPage>
        </div>
      </div>
      <div>
        <div>
          <CombinePage></CombinePage>
        </div>
      </div>
    
      <Modal
        onOpen={() => setModalOpen(true)}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        className="commentRepModal"
        dimmer="blurring"
        size="small"
        closeOnDimmerClick={false}
      >
        <Modal.Content>
          <div className="loadingModal">
            <div className="lds-default">
              <p>{notification}</p>
            </div>
          </div>
        </Modal.Content>
      </Modal>
<div style={{display:"none"}}>
      <SsaoParameters />
</div>
    </div>
  );
}
export default ModelViewerInfo;
